import PropTypes from 'prop-types';
import React from 'react';
import HorseRacingEarlyEntriesListItem from './HorseRacingEarlyEntriesListItem';

require('./HorseRacingEarlyEntriesList.scss');

export default function HorseRacingEarlyEntriesList(props = {}) {
  const {
    earlyEntries = []
  } = props;

  return (
    <div className="early-entries">
      {earlyEntries.length > 0 ?
        <div className="early-entries-list">
          {earlyEntries.map(({
            meeting_summary: {
              meeting_reference: {
                id: meetingId
              } = {}
            } = {},
            meeting_summary: meetingSummary,
            races
          }) => (
            <HorseRacingEarlyEntriesListItem key={meetingId} meetingSummary={meetingSummary} races={races}/>
          ))}
        </div>
      :
        <div className="no-early-entries">No early entries.</div>
      }
    </div>
  );
}

HorseRacingEarlyEntriesList.propTypes = {
  earlyEntries: PropTypes.arrayOf(PropTypes.object)
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingEarlyEntriesList.js